
import './bootstrap';
require('./scripts');


import { InertiaProgress } from '@inertiajs/progress'
InertiaProgress.init()

import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import pluginAuth from './Plugins/auth'

import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';

// import { createStore } from 'vuex'

// const store = createStore({
//     getters: {
//         auth(state) {
//             return {
//                 check() {
//                     return false;
//                 }
//             }
//         }
//     }
// })

// import { Inertia } from '@inertiajs/inertia'

// Inertia.on('before', (event) => {
//     console.log(event)
// });

// Components
// import Datepicker from '@vuepic/vue-datepicker';

import BrowserSessionStorage from './BrowserSessionStorage';

createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup({ el, app, props, plugin }) {
        const scolApp = createApp({ render: () => h(app, props) })
            .use(plugin)
            .use(pluginAuth)
            .use(ToastPlugin, {
                position: 'top-right'
            })
        scolApp.config.globalProperties.$route = route;
        scolApp.provide('route', scolApp.config.globalProperties.$route)
        scolApp.config.globalProperties.$session = BrowserSessionStorage.make(props.initialPage.props.session_storage);
        scolApp.provide('session', scolApp.config.globalProperties.$session)
        return scolApp.mount(el);
    },
})
